export default __webpack_public_path__ + "static/imoneybus_cover-small_1-8973eaa4e9e69484c173e63040612187.png";